<template>
  <!-- The PSN-language rule lives inside the menu, so on its own it disables the
       plan's Save button with nothing on screen to explain why. This nested observer
       (still registered with the plan's observer) surfaces that state on the activator. -->
  <validation-observer v-slot="{ invalid }" slim>
    <v-menu :close-on-content-click="false" offset-y left>
      <template v-slot:activator="{ on }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: onTip }">
            <v-btn v-on="{ ...on, ...onTip }" @click.stop icon x-small>
              <v-icon small :color="invalid ? 'error' : 'primary'"
                >mdi-tune</v-icon
              >
            </v-btn>
          </template>
          <span>{{
            invalid ? "More options - required info missing" : "More options"
          }}</span>
        </v-tooltip>
      </template>
      <v-card class="pa-4" width="90vw" max-width="340">
        <div class="text-subtitle-2 mb-3">More options</div>
        <div class="d-flex align-center mb-2">
          <span class="text-body-2 mr-3" style="min-width: 90px"
            >Unit count</span
          >
          <v-text-field
            v-model.number="servicePlan.unitCount"
            type="number"
            outlined
            dense
            hide-details
            :readonly="!editMode"
            style="max-width: 90px"
          ></v-text-field>
        </div>
        <template v-if="isSEITOrCPF">
          <v-checkbox
            v-model="servicePlan.isCompensatorySummer"
            dense
            hide-details
            :disabled="!editMode"
            class="mt-2 pt-0"
            ><template v-slot:label
              ><span class="text-body-2">Compensatory summer</span></template
            ></v-checkbox
          >
          <v-checkbox
            v-model="servicePlan.isLocationChangeAllowed"
            dense
            hide-details
            :disabled="!editMode"
            class="mt-2 pt-0"
            ><template v-slot:label
              ><span class="text-body-2"
                >Optional location change</span
              ></template
            ></v-checkbox
          >
          <v-checkbox
            v-model="isPsn"
            dense
            hide-details
            :disabled="!editMode"
            class="mt-2 pt-0"
            ><template v-slot:label
              ><span class="text-body-2">PSN language Change</span></template
            ></v-checkbox
          >
          <validation-provider :rules="{ required: isPsn }" v-slot="{ errors }">
            <v-autocomplete
              v-show="isPsn"
              v-model="servicePlan.psnLanguageId"
              :items="languages"
              item-text="name"
              item-value="languageId"
              label="PSN language"
              dense
              :disabled="!editMode"
              :clearable="editMode"
              class="mt-2 ml-6"
              :error-messages="errors"
            ></v-autocomplete>
          </validation-provider>
        </template>
      </v-card>
    </v-menu>
  </validation-observer>
</template>

<script>
export default {
  props: ["servicePlan", "editMode"],
  data() {
    return {
      isPsn: Boolean(this.servicePlan.psnLanguageId),
    };
  },
  watch: {
    isPsn(on) {
      if (!on) {
        this.servicePlan.psnLanguageId = null;
      }
    },
    // these options only exist for SEIT/CPF - when the row is switched to another
    // program they are hidden, so clear them rather than submitting stale values
    isSEITOrCPF(isApplicable) {
      if (!isApplicable && this.editMode) {
        this.isPsn = false;
        this.servicePlan.isCompensatorySummer = null;
        this.servicePlan.isLocationChangeAllowed = null;
      }
    },
  },
  computed: {
    languages() {
      return this.$store.state.optionsModule.languages || [];
    },
    isSEITOrCPF() {
      return (
        this.servicePlan.programId &&
        ["SEIT", "PEND", "CPF"].includes(
          this.$store.getters["optionsModule/getProgramCode"](
            this.servicePlan.programId
          )
        )
      );
    },
  },
};
</script>
